import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Spacing } from "@snapchat/snap-design-system";

export const lensPreviewStyle = css`
    max-width: 155px;
`;

export const defaultLayoutDetailsStyle = css`
    width: 100%;
    padding-left: ${Spacing.MD}px;
`;

export const splitPanelLayoutDetailsStyle = css`
    width: 100%;
`;

export const LensDetailsName = styled.span`
    padding-bottom: ${Spacing.MD}px;

    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${Colors.Black.V200};
`;

export const lensEditDetailsRowFullWidth = css`
    width: 100%;
`;

export const lensEditDetailsRowTitle = css`
    padding-bottom: 0;
`;

export const lensEditDetailsRowSpacing = css`
    padding-bottom: ${Spacing.MD}px;
`;

export const lensTabSpacing = css`
    margin-bottom: ${Spacing.MD}px;
`;
